import { useState, useEffect, useRef } from "react";

const CreateIssues = ({
  options = [],
  placeholder = "Select User Type",
  onChange,
  defaultValue = "",
  value,
  name = "",
  className = "",
  readOnly = false,
}) => {
  const [selectedOption, setSelectedOption] = useState(() => {
    if (defaultValue) {
      return options.find((opt) => opt.value === defaultValue) || null;
    }
    return options[0] || null;
  });

  const [isOpen, setIsOpen] = useState(false);
  const [searchText, setSearchText] = useState("");
  const dropdownRef = useRef(null);

  // Controlled value sync
  useEffect(() => {
    if (value !== undefined) {
      const matched = options.find((opt) => opt.value === value);
      if (matched) {
        setSelectedOption(matched);
      }
    }
  }, [value, options]);

const handleSelect = (option, index) => {
  if (readOnly) return;
  if (option.disabled) return; // instead of index === 0
  setSelectedOption(option);
  setIsOpen(false);
  setSearchText("");
  if (onChange) {
    onChange(option.value);
  }
};

  // Close on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Visibility cleanup for animation
  useEffect(() => {
    const element = dropdownRef.current?.querySelector(".select-items");
    if (!element) return;
    if (!isOpen) {
      const timeout = setTimeout(() => {
        element.style.visibility = "hidden";
      }, 300);
      return () => clearTimeout(timeout);
    } else {
      element.style.visibility = "visible";
    }
  }, [isOpen]);

  // Filtered options based on search
  const filteredOptions = options.filter((opt) =>
    opt.label.toLowerCase().includes(searchText.toLowerCase())
  );

  return (
    <div className={`custom-select ${className} ${isOpen ? "open" : ""}`} ref={dropdownRef}>
      <div
        className={`form-control ${readOnly ? "disabled-option" : ""}`}
        onClick={() => {
          if (!readOnly) setIsOpen((prev) => !prev);
        }}
      >
        {selectedOption?.color && (
          <span className="priority-icon" style={{ background: selectedOption.color }}></span>
        )}
        {selectedOption ? selectedOption.label : placeholder}
      </div>

      {/* Dropdown Content */}
      <div className="select-items">
        {isOpen && (
          <div className="innerscrollbar innerscrollbar02">
            <input
              type="text"
              placeholder="Search..."
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              className="search-box"
            />
            <div className="optiondropdown">
            {filteredOptions.length > 0 ? (
              filteredOptions.map((option, index) => (
                <div
                  key={option.value}
                  onClick={() => handleSelect(option, index)}
                  className={`option-item ${selectedOption?.value === option.value ? "same-as-selected" : ""}`}
                >
                  {option.color && (
                    <span className="priority-icon" style={{ background: option.color }}></span>
                  )}{" "}
                  {option.label}
                </div>
              ))
            ) : (
              <div className="no-results">No results found</div>
            )}
            </div>
          </div>
        )}
      </div>

      <input type="hidden" name={name} value={selectedOption?.value || ""} />
    </div>
  );
};

export default CreateIssues;
